import React from 'react'
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Paper from 'components/Paper'
import T from 'components/FormattedMessage'
import MatchCard from 'components/MatchCard'
import Jersey from 'components/Jersey'
import { IMatch } from 'protos'
import { format } from 'date-fns'

type PaperProps = React.ComponentProps<typeof Paper>
type JerseySize = React.ComponentProps<typeof Jersey>['size']

type FeaturedMatchProps = PaperProps & {
  match: IMatch,
  jerseySize?: JerseySize
}

const styles = (theme: Theme) => createStyles({
  root: {
    backgroundColor: 'transparent',
    paddingBottom: theme.spacing() * 10,
  },
  grid: {
    paddingTop: theme.spacing() * 2,
    paddingBottom: theme.spacing() * 2,
    backgroundColor: theme.palette.grey[50],
    borderBottom: `1px solid ${theme.palette.grey[100]}`
  },
  jerseyContainer: {
    overflow: 'hidden'
  },
  leftJersey: {
    transform: 'translateX(-50%)',
  },
  rightJersey: {
    transform: 'translateX(50%)'
  },
  matchContainer: {
    padding: theme.spacing() * 2,
    marginTop: theme.spacing() * -10,
    marginBottom: theme.spacing() * -10,
  },
  title: {
    fontSize: 14,
    fontWeight: 700, // theme.typography.fontWeightMedium
    textTransform: 'uppercase'
  },
  date: {
    fontSize: 12,
    fontWeight: theme.typography.fontWeightMedium
  }
})

type InjectedProps = FeaturedMatchProps & PaperProps & WithStyles<typeof styles>

const FeaturedMatch: React.SFC<InjectedProps> = ({
  match, classes, color = 'default', jerseySize = 'xlarge', ...props
}) => (
    <Paper
      color={color}
      {...props}
      className={classes.root}
    >
      <Grid container alignItems="flex-start" spacing={0} className={classes.grid}>
        <Grid item xs={4} className={classes.jerseyContainer}>
          <Grid container>
            <Jersey
              size={jerseySize || 'medium'}
              jersey={match.homeTeam!.jersey!}
              className={classes.leftJersey}
            />
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <Grid container alignItems="center" direction="column">
            <Typography gutterBottom color="textSecondary" className={classes.title}>
              <T id="game_featured_title" />
            </Typography>
            <Typography color="textSecondary" align="center" className={classes.date}>
              {format(Number(match.kickoff) * 1000, 'iiii do LLLL')}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={4} className={classes.jerseyContainer}>
          <Grid container justify="flex-end">
            <Jersey
              size={jerseySize}
              jersey={match.awayTeam!.jersey!}
              className={classes.rightJersey}
            />
          </Grid>
        </Grid>
      </Grid>

      <div className={classes.matchContainer}>
        <MatchCard match={match} />
      </div>
    </Paper>
  )

export default withStyles(styles)(FeaturedMatch)
